<template>
    <div>
        <table class="w-full d-none d-md-table">
            <thead class="h-11 bg-lightGray">
            <tr class="font-weight-bold">
                <td class="px-3">#</td>
                <td>{{ $t('product.name') }}</td>
                <td>{{ $t('warehouse.remainder') }}</td>
                <td>{{ $t('autoOrder.order') }}</td>
                <td>{{ $t('autoOrder.sold') }}</td>
                <td>{{ $t('autoOrder.soldOutDate') }}</td>
                <td class="d-none d-xl-table-cell">{{ $t('autoOrder.avgSaleRate') }}</td>
                <td class="d-none d-xl-table-cell">{{ $t('autoOrder.marja') }}</td>
                <td class="d-none d-xl-table-cell">{{ $t('supplier.title') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in getOrder.autoOrderItems" :key="index" class="h-11">
                <td class="px-3">{{ index + 1 }}</td>
                <td>{{ item.product.name }}</td>
                <td>{{ numberWithCommas(parseFloat(item.residue)) }} {{ showUnitOfMeasure(item.product.unitOfMeasure) }}</td>
                <td>{{ numberWithCommas(parseFloat(item.orderAmount)) }} {{ showUnitOfMeasure(item.product.unitOfMeasure) }}</td>
                <td>{{ numberWithCommas(parseFloat(item.sold)) }}</td>
                <td>{{ item.soldOutDate ? dateTimeFormat(item.soldOutDate) : '----' }}</td>
                <td class="d-none d-xl-table-cell">{{ parseFloat(item.averageSaleRate) }}</td>
                <td class="d-none d-xl-table-cell">{{ item.marja }} %</td>
                <td class="d-none d-xl-table-cell">{{ getSupplierName(item) }}</td>
            </tr>
            </tbody>
        </table>

        <table class="w-full d-md-none">
            <tbody v-for="(item, index) in getOrder.autoOrderItems" :key="index">
                <tr class="h-11">
                    <td class="font-bold pl-2">#</td>
                    <td>{{ index + 1 }}</td>
                </tr>
                <tr class="h-11">
                    <td class="font-bold pl-2">{{ $t('product.name') }}</td>
                    <td>{{ item.product.name }}</td>
                </tr>
                <tr class="h-11">
                    <td class="font-bold pl-2">{{ $t('autoOrder.order') }}</td>
                    <td>{{ numberWithCommas(parseFloat(item.residue)) }} {{ showUnitOfMeasure(item.product.unitOfMeasure) }}</td>
                </tr>
                <tr class="h-11">
                    <td class="font-bold pl-2">{{ $t('autoOrder.sold') }}</td>
                    <td>{{ numberWithCommas(parseFloat(item.sold)) }}</td>
                </tr>
                <tr class="h-11">
                    <td class="font-bold pl-2">{{ $t('autoOrder.soldOutDate') }}</td>
                    <td>{{ item.soldOutDate ? dateTimeFormat(item.soldOutDate) : '----' }}</td>
                </tr>
                <tr class="h-11">
                    <td class="font-bold pl-2">{{ $t('autoOrder.avgSaleRate') }}</td>
                    <td>{{ parseFloat(item.averageSaleRate) }}</td>
                </tr>
                <tr class="h-11">
                    <td class="font-bold pl-2">{{ $t('autoOrder.marja') }}</td>
                    <td>{{ item.marja }} %</td>
                </tr>
                <tr class="h-11" style="border-bottom: 5px solid #777777">
                    <td class="font-bold pl-2">{{ $t('supplier.title') }}</td>
                    <td>{{ getSupplierName(item) }}</td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "OrderItemListTable",
    components: {},
    mixins: [dateFormattingMixin, currencyFormatMixin],
    computed: {
        ...mapGetters(['getOrder'])
    },
    methods: {
        ...mapActions(['fetchOrder']),
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        getSupplierName(item) {
            if (item.supplier === null) {
                return '';
            }

            return item.supplier.isCompany ?
                item.supplier.supplierCompany.name :
                item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
    },
    mounted() {
        this.$root.showOverlay = true
        this.fetchOrder(this.$route.params.id)
            .then(() => {
            })
            .finally(() => {
                this.$root.showOverlay = false
            })
    }
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>